.container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
}

/*
 * 56px tall, the height AppChrome keeps clear and the Fab and snackbar sit above. With 4px padding it was 61px, and
 * the bottom 5px of every page ran under it (GH #3062). min-height, so larger text still grows it.
 */
.nav {
  display: flex;
  justify-content: space-around;
  align-items: center;
  box-sizing: border-box;
  min-height: 56px;
  background-color: var(--tuna-palette-layers);
  border-top: 1px solid var(--tuna-palette-divider);
}

.navButton {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 12px;
  font-size: var(--tuna-typography-fontSize-xs);
}
